import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllContactFormData, DeleteContactForm } from "helpers/api_method";

export const getAllContactFOrmDataEntries = createAsyncThunk("contactForm/getAllContactFOrmDataEntries", async () => {
    try {
        const response = await GetAllContactFormData();
        return response.data;
    } catch (error) {
        return error;
    }
});

export const deleteContactFormEntry = createAsyncThunk("contactForm/deleteContactFormEntry", async (id: string) => {
    try {
        const response = await DeleteContactForm(id);
        toast.success("Contact form entry deleted successfully");
        return id;
    } catch (error) {
        toast.error("Failed to delete contact form entry");
        throw error;
    }
});
